.textarea {
  height: auto;
  resize: vertical;
  vertical-align: bottom;
  padding-bottom: var(--dds-spacing-x0-5);
}
